export default __webpack_public_path__ + "562268fb609ef4b2dc13ccfdfa3f0127.png";